import classes from './Header.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Heading from '../../../Heading/Heading';

function Header(props) {
  let { children, className, center } = props;
  let content = children.type ? (
    children
  ) : (
    <Heading size={3} className={classes.heading}>
      {children}
    </Heading>
  );

  return (
    <div
      className={classnames(
        {
          [classes.center]: center
        },
        classes.base,
        className
      )}
    >
      {content}
    </div>
  );
}

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]),
  center: PropTypes.bool,
  className: PropTypes.string
};

export default Header;
